module.exports = __webpack_public_path__ + "static/succulents-33d5cc144e054009da15ad77eff360b5.png";